import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationRoutingModule } from './administration-routing.module';
import { RegistrationsListComponent } from './registrations/registrations-list/registrations-list.component';
import { RegistrationCreateComponent } from './registrations/registration-create/registration-create.component';
import { RegistrationService } from './registrations/registration.service';
import { OutingCreateComponent } from './outings/outing-create/outing-create.component';
import { CourseCreateComponent } from './course/course-create/course-create.component';
import { CourseService } from './course/course.service';
import { OutingDetailsComponent } from './outings/outing-details/outing-details.component';
import { OutingsListComponent } from './outings/outings-list/outings-list.component';
import { OutingPermissionCreateComponent } from './outings/outing-permission-create/outing-permission-create.component';
import { CourseDetailsComponent } from './course/course-details/course-details.component';
import { CoursesListComponent } from './course/courses-list/courses-list.component';
import { OutingIterationListComponent } from './outings/outing-iteration-list/outing-iteration-list.component';
import { OutingIterationCreateComponent } from './outings/outing-iteration-create/outing-iteration-create.component';
import { OutingIterationEditComponent } from './outings/outing-iteration-edit/outing-iteration-edit.component';
import { PrizeListComponent } from './prize/prize-list/prize-list.component';
import { PrizeCreateComponent } from './prize/prize-create/prize-create.component';
import { PrizeDetailsComponent } from './prize/prize-details/prize-details.component';
import { OutingIterationDetailsComponent } from './outings/outing-iteration-details/outing-iteration-details.component';
import { OutingIterationDetailsCreateComponent } from './outings/outing-iteration-details-create/outing-iteration-details-create.component';
import { SponsorListComponent } from './sponsor/sponsor-list/sponsor-list.component';
import { SponsorCreateComponent } from './sponsor/sponsor-create/sponsor-create.component';
import { SponsorDetailsComponent } from './sponsor/sponsor-details/sponsor-details.component';
import { SponsorEditComponent } from './sponsor/sponsor-edit/sponsor-edit.component';
import { PrizeEditComponent } from './prize/prize-edit/prize-edit.component';
import { RegistrationsTeamsComponent } from './registrations/registrations-teams/registrations-teams.component';
import { OutingService } from '../outing/outing.service';
import { SharedModule } from '../shared/shared.module';
import { OutingEditModalComponent } from './outings/outing-edit-modal/outing-edit-modal.component';



@NgModule({
  declarations: [
      RegistrationsListComponent,
      RegistrationCreateComponent,
      OutingCreateComponent,
      CourseCreateComponent,
      OutingEditModalComponent,
      OutingDetailsComponent,
      OutingsListComponent,
      OutingPermissionCreateComponent,
      CourseDetailsComponent,
      CoursesListComponent,
      OutingIterationListComponent,
      OutingIterationCreateComponent,
      OutingIterationEditComponent,
      PrizeListComponent,
      PrizeCreateComponent,
      PrizeDetailsComponent,
      OutingIterationDetailsComponent,
      OutingIterationDetailsCreateComponent,
      SponsorListComponent,
      SponsorCreateComponent,
      SponsorDetailsComponent,
      SponsorEditComponent,
      PrizeEditComponent,
      RegistrationsTeamsComponent
  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    SharedModule,
  ],
  exports: [
    RegistrationsListComponent,
    OutingCreateComponent
  ],
  providers: [
    RegistrationService,
    CourseService,
    OutingService
  ]
})
export class AdministrationModule { }
